export const SignalRListenerConstants = {
  STORE_WEB_PAYMENT_STATUS: "STORE_WEB_PAYMENT_STATUS",
  STORE_WEB_ORDER_COMPLETED: "STORE_WEB_ORDER_COMPLETED",
};

export const EnumNotification  = {
  NotificationCampaign: 0,
  Order: 1,
};
